export const enum ToolbarStates {
  SYMBOL = 'symbol',
  EL_ANIMATION = 'elAnimation',
  EL_NORMALDATA = 'normalData',
  EDIT_DATAS = 'editDatas',
  EL_TEMPLATEDATA = 'elTemplateData',
  EL_STYLE = 'elStyle',
  EL_POSITION = 'elPosition',
  SLIDE_DESIGN = 'slideDesign',
  SLIDE_ANIMATION = 'slideAnimation',
  MULTI_POSITION = 'multiPosition',
}